<template>
    <div class="noResult-container">
        <i></i>
        <p>暂无识别内容</p>
    </div>
</template>

<script>
export default {
    name: 'newMaterialNoResult'
}
</script>

<style lang="less" scoped>
    .noResult-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 116px;

        i {
            display: block;
            width: 44px;
            height: 44px;
            background: url('../../../common/newMaterialBox/assets/noResult.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-bottom: 14px;
        }

        p {
            font-size: 14px;
            line-height: 20px;
            color: #050F0F;
        }
    }

</style>